import {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/modals/auth/recovery';
import {AccountRecovery} from '../../../../reducers/modals/actions';
import ModalsLib from '../../../../lib/modals';

import Choose from './choose';
import Username from './username';
import PasswordEnter from './password-enter';
import PasswordCode from './password-code';
import PasswordReset from './password-reset';

import Triggers from '../../../../lib/triggers';

export default () => {
    const {stage, data} = useSelector(Selector),
          dispatch = useDispatch();

    const modalCloseHandler = () => dispatch(AccountRecovery.stage('choose'));

    useEffect(() => {
        document.addEventListener('modal.close', modalCloseHandler);

        Triggers.modal_open({
            modal: "recovery"
        });

        return () => document.removeEventListener('modal.close', modalCloseHandler);
    }, []);

    return (
        <div className="modal auth animate__animated animate__fadeInUp animate__faster">
            {stage === 'choose' && <Choose data={data} />}
            {stage === 'username' && <Username data={data} />}
            {stage === 'password_enter' && <PasswordEnter data={data} />}
            {stage === 'password_code' && <PasswordCode data={data} />}
            {stage === 'password_reset' && <PasswordReset data={data} />}
        </div>
    )
}